import { gql } from '@apollo/client';

const GET_PRODUCTS_VARIANTS = gql`
  query productVariants($params: QueryParams, $name: String) {
    productVariants(params: $params, name: $name) {
      info {
        count
      }
      results {
        id
        title
        img
        description
        price
        product {
          id
          name
          description
        }        
      }     
    }
  }
`;

const GET_GROUPS_COUPONS = gql`
  query groupsCoupon($params: QueryParams) {
    groupsCoupon(params: $params) {
      info {
        count
      }
      results {
        id
        group
      }     
    }
  }
`;

const CREATE_COUPON = gql`
  mutation CreateCoupon(
    $coupon: CouponCreateInput!
    $product: ProductCreateInput
    $productVariants: [ProductVariantCreateInput]
  ) {
    createCoupon(
      coupon: $coupon
      product: $product
      productVariants: $productVariants
    ) {
      success
      message
      coupon { 
        id
      }  
    }
  }
`;

export { GET_PRODUCTS_VARIANTS, CREATE_COUPON, GET_GROUPS_COUPONS }
